import { render } from "./raceSignInfo.vue?vue&type=template&id=9b50872e&scoped=true"
import script from "./raceSignInfo.vue?vue&type=script&lang=js"
export * from "./raceSignInfo.vue?vue&type=script&lang=js"

import "./raceSignInfo.vue?vue&type=style&index=0&id=9b50872e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b50872e"]])

export default __exports__